import * as types from './actionTypes';
import { actionService } from '../_services';

export function fetchActionTypes() {
  return dispatch => {
    return actionService
      .fetchActionTypes()
      .then(payload => {
        dispatch(success(payload));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function success(payload) {
    return { type: types.FETCH_ACTION_LIST, payload: payload };
  }
  function failure(error) {
    return { type: types.FETCH_ACTION_LIST_FAILURE, error };
  }
}
